const SafetyIconEarDefenders = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M8 21.75C8 21.087 8.26339 20.4511 8.73223 19.9822C9.20107 19.5134 9.83696 19.25 10.5 19.25H11.75C12.413 19.25 13.0489 19.5134 13.5178 19.9822C13.9866 20.4511 14.25 21.087 14.25 21.75V25.5C14.25 26.163 13.9866 26.7989 13.5178 27.2678C13.0489 27.7366 12.413 28 11.75 28H10.5C9.83696 28 9.20107 27.7366 8.73223 27.2678C8.26339 26.7989 8 26.163 8 25.5V21.75ZM21.75 21.75C21.75 21.087 22.0134 20.4511 22.4822 19.9822C22.9511 19.5134 23.587 19.25 24.25 19.25H25.5C26.163 19.25 26.7989 19.5134 27.2678 19.9822C27.7366 20.4511 28 21.087 28 21.75V25.5C28 26.163 27.7366 26.7989 27.2678 27.2678C26.7989 27.7366 26.163 28 25.5 28H24.25C23.587 28 22.9511 27.7366 22.4822 27.2678C22.0134 26.7989 21.75 26.163 21.75 25.5V21.75Z"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 21.75V18C8 15.3478 9.05357 12.8043 10.9289 10.9289C12.8043 9.05357 15.3478 8 18 8C20.6522 8 23.1957 9.05357 25.0711 10.9289C26.9464 12.8043 28 15.3478 28 18V21.75"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SafetyIconEarDefenders
